import SlimNotification from './SlimNotification';
export default SlimNotification;
